import jobActions from 'actions/jobs'
import operatorActions from 'actions/operators'
import jobTemplateActions from 'actions/jobTemplates'
import filterTemplateActions from 'actions/filterTemplates'
import taskManagerActions from 'actions/reports/taskManager'

export const tasksFormViewExtraDispatchToProps = (dispatch, props) => ({
  runNow: (taskId) => dispatch(taskManagerActions.runNow(taskId)),
  getJobTemplates: (params) => dispatch(jobTemplateActions.getOptions(params)),
  getFilterTemplates: (params) => dispatch(filterTemplateActions.getOptions(params)),
  getFilterTemplateTypes: () => dispatch(filterTemplateActions.getFilterTypes()),
  getOperator: (operatorId) => dispatch(operatorActions.getItem(operatorId)),
  createFromTemplate: (jobId, params) => dispatch(jobActions.createFromTemplate(jobId, params)),
  getOperators: (params) =>
    dispatch(
      operatorActions.getOptions({
        pageIndex: 1,
        pageSize: 100,
        ...params,
        active: 'Active',
      })
    ),
})
